import { CommonModule } from '@angular/common';
import { Component, OnInit  } from '@angular/core';
import { Router } from '@angular/router';
import { PayrollService } from 'src/app/shared/services/payrollservices/payroll.service';
import { FormsModule } from '@angular/forms';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-payroll-list',
  imports: [CommonModule, FormsModule],
  templateUrl: './payroll-list.component.html',
  styleUrl: './payroll-list.component.css'
})
export class PayrollListComponent implements OnInit {
 isLoading = true;
  salaries: any;
 months: { name: string, value: number }[] = [
  { name: 'January', value: 1 },
  { name: 'February', value: 2 },
  { name: 'March', value: 3 },
  { name: 'April', value: 4 },
  { name: 'May', value: 5 },
  { name: 'June', value: 6 },
  { name: 'July', value: 7 },
  { name: 'August', value: 8 },
  { name: 'September', value: 9 },
  { name: 'October', value: 10 },
  { name: 'November', value: 11 },
  { name: 'December', value: 12 }
];
    years: number[] = [];

  selectedMonth = '';
  selectedYear: number | null = null;

  constructor(

    public payrollService: PayrollService,
    public router: Router,
  ) {

  }
   ngOnInit(): void {
    // Simulate API loading
    setTimeout(() => {
      this.isLoading = false;
    }, 2000);
    const currentYear = new Date().getFullYear();
    for (let i = 0; i < 10; i++) {
      this.years.push(currentYear - i);
    }
    this.getAllPayroll();
   
  }

  


  getAllPayroll(month?: string, year?: number) {
    this.payrollService.getPayroll(month, year).then((value) => {
      if (value.success) {
        this.salaries = value.data;
        this.isLoading = false;
      } else {
        this.showError("Something went wrong!");
        this.isLoading = false;
      }
    }).catch(() => {
      this.showError("Something went wrong!");
       this.getAllPayroll();
      this.isLoading = false;
    });
  }



   showError(message: string) {
          Swal.fire({
            iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: message,
          showConfirmButton: false,
          timer: 3000,
        });
      }




    showSlip(data: any) {
      this.router.navigate(['/payroll-sheet'], {
      queryParams: { data: JSON.stringify(data) },
      skipLocationChange: true,
    });
  }

   loanreq() {
      this.router.navigate(['/payroll'], { queryParams: { fromLoanRequest: true } })
  }

applyFilter() {
  if (!this.selectedMonth || !this.selectedYear) {
    this.showError('Please select both Month and Year!');
    return;
  }

  this.isLoading = true;

  // Call API with selectedMonth and selectedYear
  this.getAllPayroll(this.selectedMonth, this.selectedYear);
}



}
